import React from 'react'
import AdminTalentMangersStep from './AdminTalentManagersStep'

const AdminTalentManagers = () => {
  return (
    <div className='AdminDashboard'>
    <div className='AdminPage_Dashboard'>
        <div className='AdminPage_DashboardTAbleCat'>
            <AdminTalentMangersStep />
            </div>
    </div>
    </div>
  )
}

export default AdminTalentManagers